/**
 * Post Show Modal Setup
 *
 * Initializes PostShow event delegation for modal usage (index pages, etc.)
 * without triggering page-level side effects (e.g., mark-as-read on page).
 */

import type { EventRoot } from "../../core/event-scope/event-scope-types";
import { PostShowApiService } from "./post-show-api";
import { PostShowHandler } from "./post-show-handler";
import { PostShowListener } from "./post-show-listener";
import { PostShowStateHandler } from "./post-show-state-handler";
import { PostShowSetup } from "./post-show-setup";

export interface PostShowModalSetupContext {
    stateManager: PostShowStateHandler;
    apiService: PostShowApiService;
    handler: PostShowHandler;
    listener: PostShowListener;
}

export class PostShowModalSetup {
    public static async init(root: EventRoot): Promise<PostShowModalSetupContext> {
        const boardId = PostShowSetup.getBoardId();

        const stateManager = new PostShowStateHandler();
        const apiService = new PostShowApiService();
        const handler = new PostShowHandler(stateManager, apiService);
        const listener = new PostShowListener(handler);

        stateManager.init(boardId);
        listener.setup(root);

        return { stateManager, apiService, handler, listener };
    }
}
